// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Skta","addWidgetButton":"Header_addWidgetButton__1qgOF","dashboardTabs":"Header_dashboardTabs__1Od7j","active":"Header_active__3vZph"};